'use strict';

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function objectHasKeys(obj) {
  return obj && (0, _keys["default"])(obj).length > 0;
}

module.exports = objectHasKeys;